/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  display: none;
  padding: calc(24rem/14);
}

:host([selected]) {
  display: block;
}`;
export { style };
//# sourceMappingURL=Tab.style.js.map